import { Avatar, Box, chakra } from "@chakra-ui/react";

export const StyledSidebarContainer = chakra(Box, {
  baseStyle: {
    width: ["260px", "300px", "340px"], // responsive: sm, md, lg
    height: "100%",
    display: "flex",
    justifyContent: "space-between",
    //position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    flexDirection: "column",
    transition: "all",
    transitionDuration: "0.3s",
    transitionProperty: "all",
    //boxShadow: "md",
    //borderRadius: "md",
    //my: "10px",
    bgColor: "white",
    flex: 1,
  },
});

export const StyledSidebarSubBox = chakra(Box, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    overflowY: "scroll",
  },
});

export const StyledSidebarItem = chakra(Box, {
  baseStyle: {
    display: "flex",
    borderRadius: "8px",
    cursor: "pointer",
  },
});

export const StyledUserTag = chakra(Box, {
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    bg: "theme.alert.200",
    borderRadius: "4px",
    color: "theme.button.primary",
    fontSize: "10px",
    fontWeight: 500,
    paddingX: "5px",
    height: "18px",
    noOfLines: 1,
    maxW: "80px",
    textOverflow: "ellipsis",
    whiteSpace: "pre-wrap",
  },
});

export const StyledResLaguageContainer = chakra(Box, {
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    cursor: "pointer",
  },
});

export const StyledProfileAvatar = chakra(Avatar, {
  baseStyle: {
    width: "40px",
    height: "40px",
    fontSize: "13px",
    fontWeight: 500,
    bg: "#72A7DA",
    cursor: "pointer",
    color: "#0D0D0D",
  },
});
